import { minBy } from 'lodash';
import CustomerType from '@/contact/constants/CustomerType';
import ContactContext from '@/contact/models/ContactContext';
import DossierContact from '@/contact/models/DossierContact';
import MediaContext2 from '@/general/models/MediaContext2';
import JobContext from '@/jobs/models/JobContext';
import AbstractContext from '@/shared/models/AbstractContext';
import { isPresent } from '@/shared/utils/typescript';
import TiresSummary from '@/tires/models/TiresSummary';
import Dossier from './Dossier';
import DossierVehicle from './DossierVehicle';
import Fluid from './Fluid';
import DriveBookingContext from '@/driveBookings/models/DriveBookingContext';

export default class DossierContext extends AbstractContext {
  fluids: Array<Fluid> = [];

  constructor(
    public dossier: Dossier,
    public tiresSummary: TiresSummary | null,
    readonly contactContext: ContactContext,
    readonly dossierVehicle: DossierVehicle,
    readonly jobContext: JobContext,
    readonly mediaContext: MediaContext2,
    readonly driveBookingContext: DriveBookingContext,
  ) {
    super();
    this.fixVehicleCountry();
  }

  canApprovePrices(contact: DossierContact): boolean {
    if (this.dossier.isLeasing) return false;
    if (!contact.isLeasing && this.contactContext.hasLeasingContacts()) return false;
    return !(contact.customer.type === CustomerType.DRIVER && !this.contactContext.hasLeasingContacts() && this.contactContext.hasNonDrivers());
  }

  /**
   * "temporary" WORKAROUND for missing countryId in back-end vehicle model
   */
  private fixVehicleCountry(): void {
    const contactsWithCountry = this.contactContext.contacts.filter(c => isPresent(c.customer.country?.id));
    const contact = minBy(contactsWithCountry, 'customer.type');
    if (contact) this.dossierVehicle.vehicle.countryId = this.dossierVehicle.vehicle.countryId ?? contact.customer.country!.id!;
  }

  getReplenishedFluids(): Array<Fluid> {
    return this.fluids.filter(f => f.isPresent());
  }

  free(): void {
    super.free();
    this.jobContext.free();
    this.mediaContext.free();
    this.driveBookingContext.free();
  }
}